import getTimezoneAbbr from 'Helper/getTimezoneAbbr';
import moment from 'moment';
import Cookies from 'universal-cookie';

export const getRequestApprovalByIdResponse = (response) => {
  const { data } = response;
  const reschedule = data?.reschedule;
  const cookies = new Cookies();

  const timezone = cookies.get('organization')?.timezone;
  const abbr = getTimezoneAbbr(timezone);

  const dateTime = `${moment(reschedule?.schedule?.startedAt).format('DD MMMM YYYY, HH:mm')} ${abbr}`;

  const result = {
    id: reschedule?.id ?? '-',
    typeId: reschedule?.typeId ?? '-',
    reason: reschedule?.reason ?? '-',
    statusProgress: reschedule?.statusProgress ?? '-',
    createdAt: reschedule?.createdAt ?? '-',
    type: reschedule?.type ?? '-',
    schedule: reschedule?.schedule ? { title: reschedule?.schedule?.title, dateTime } : { title: '-', dateTime: '-' },
    targetSchedule: reschedule?.targetSchedule
      ? { title: reschedule?.targetSchedule?.title, dateTime: moment(reschedule?.targetSchedule?.startedAt).format('DD MMMM YYYY, HH:mm') }
      : { title: '-', dateTime: '-' },
    hostRequester: reschedule?.hostRequester?.name ?? '-',
    hostRequesterWithAccount:
      `${reschedule?.hostRequester?.name} - ${reschedule?.schedule?.brandNames}(${reschedule?.schedule?.accountLivestreamNames})` ?? '-',
    targetUserWithAccount:
      `${reschedule?.targetUser?.name} - ${reschedule?.targetSchedule?.brandNames}(${reschedule?.targetSchedule?.accountLivestreamNames})` ?? '-',
    targetUser: reschedule?.targetUser?.name ?? '-',
    rawData: reschedule,
    exchangeIconLabel: reschedule?.typeId === 1 ? 'Tukar Jadwal' : 'Ganti Host',
    isScheduleChange: reschedule?.typeId === 1,
    images: reschedule?.images?.map((img) => img?.name) ?? [],
  };

  return result;
};

export default getRequestApprovalByIdResponse;
